import React from "react";

/**
 * Array of footer link objects containing details for rendering footer links.
 * @type {Array<Object>}
 * @property {string} href - The URL to which the link points.
 * @property {string} label - The text displayed for the link.
 * @property {string} title - The tooltip text displayed on hover.
 */
const footerLinks = [
  {
    href: "https://www.saep.it/faq/",
    label: "Info",
    title: "Frequently Asked Questions",
  },
  {
    href: "https://www.iubenda.com/privacy-policy/50130093",
    label: "Privacy",
    title: "Privacy Policy",
  },
  {
    href: "https://www.saep.it/contatti/",
    label: "Contatti",
    title: "Contact Us",
  },
];

/**
 * Footer component for displaying a list of links.
 *
 * @returns {JSX.Element} The rendered footer component.
 */
const Footer = () => {
  return (
    <footer>
      {footerLinks.map(({ href, label, title }, index) => (
        <a
          key={index}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          title={title}
        >
          {label}
        </a>
      ))}
    </footer>
  );
};

export default Footer;
